





















import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalCodeArea } from '@/components/modals/ModalCodeArea'
import {
  AlertMessage,
  defaultSystemCodeArea,
  ErrorMessage,
  SystemCodeArea,
  systemCodeAreaApi
} from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { AtomTextField } from '@/components/atoms'
import { merge } from 'lodash'

const CODE_MAX_LENGTH = 6

@Component({
  components: {
    ModalCodeArea
  }
})
export default class InputCodeArea extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Ref()
  modalCodeArea!: ModalCodeArea

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: Object })
  value!: SystemCodeArea

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: [Number, String],
    default: 5
  })
  rows!: number | string

  @Prop({
    type: Boolean,
    default: true
  })
  noResize!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  flat!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  outlined!: boolean

  get mask(): string {
    return 'X'.repeat(6)
  }

  get name(): string {
    return this.value.name
  }

  onInput(value: string) {
    if (value.length === CODE_MAX_LENGTH) {
      this.fetchAreaCode(value)
    }

    this.$emit('input', merge(defaultSystemCodeArea(), { code: value }))
  }

  onModalCodeAreaInput(item: SystemCodeArea) {
    this.$emit('input', item)
  }

  @Emit('click:list')
  onListClick(): void {
    this.modalCodeArea.open()
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}

  async fetchAreaCode(code: string) {
    try {
      const items = await systemCodeAreaApi.getAllSystemCodeArea(code)
      if (items.length > 0) {
        this.$emit('input', items[0])
      } else {
        this.$emit('input', merge(defaultSystemCodeArea(), { code }))
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }
}
